// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"793b29cf","453":"2705be7f","636":"d8ded5ec","787":"db13acc1"}[chunkId] + ".chunk.js";
};